module.exports = __webpack_public_path__ + "img/acc-icon.969ce358.svg";